module.exports = __webpack_public_path__ + "img/pic1.3123c795.png";